// src/directives/longPress.js
export default {
  beforeMount(el, binding) {
    let pressTimer = null;

    const handler = () => {
      if (typeof binding.value === 'function') {
        binding.value();
      }
    };

    const start = (e) => {
      if (e.type === 'click' && e.button !== 0) return;
      if (pressTimer === null) {
        pressTimer = setTimeout(handler, 700); // 700ms para long press
      }
    };

    const cancel = () => {
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    };

    // Bind the events
    el.addEventListener('mousedown', start);
    el.addEventListener('touchstart', start);
    el.addEventListener('click', cancel);
    el.addEventListener('mouseout', cancel);
    el.addEventListener('touchend', cancel);
    el.addEventListener('touchcancel', cancel);
  },
};
